import React from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Icon} from '@optimaxdev/icons';
import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeature} from 'components/feature';
import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {ApplicationStoreType} from 'desktop/store';
import {PayerInfoType} from 'desktop/types/payerInfoType';

import {PAYMENTS} from '../../constants/paymentStep';
import * as CardsIcon from '../../img/cards.svg';
import {setOptionPaymentMethod} from '../../store/reducers/analytics/analytics';
import {sendPayerInfoToSaga} from '../../store/reducers/paymentStep/payerInfo/payerInfo';
import {getErrorMessage} from '../../store/selectors/creditCard/creditCard';
import {getIsSelectedByKey} from '../../store/selectors/paymentStep/paymentStep';
import {PaymentCreditCardConnected} from '../paymentCreditCard/paymentCreditCard';
import {PaymentWrapperConnected} from '../paymentWrapper/paymentWrapper';

import s from './paymentCreditCardWrapper.scss';

export type PropsType = {
    isSelected: boolean;
    error: string;
    setOptionPayment: () => void;
    sendPayerInfo: (data: PayerInfoType) => void;
};

/**
 * credit card wrapper for checkout
 *
 * @constructor
 */
export const PaymentCreditCardWrapper: React.FC<PropsType> = ({error = '', ...props}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const sendAnalytics = () => {
        sendDesktopAnalyticsPerSession({
            event: CHECKOUT_PAYMENT_STEP,
            label: {
                message: 'Credit Card - Card image clicked',
                method: 'Payment',
            },
        });
    };
    return (
        <PaymentWrapperConnected
            rightSideIcon={
                <Icon
                    className={s.cards}
                    height={23}
                    icon={CardsIcon}
                    label="CardsIcon"
                    onClick={sendAnalytics}
                    width={245}
                />
            }
            title={
                <div className={s.title}>
                    <span>Credit card</span>
                </div>
            }
            code={PAYMENTS.METHOD_CREDIT_CARD}
            isSelected={props.isSelected}
        >
            <div className={classNames(s.container, {[s.containerFacelift]: isFacelift})}>
                <PaymentCreditCardConnected />
            </div>
            {error && <div className={s.error}>{error}</div>}
        </PaymentWrapperConnected>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux stores
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    error: getErrorMessage(store),
    isSelected: getIsSelectedByKey(store, PAYMENTS.METHOD_CREDIT_CARD),
});

export const PaymentCreditCardWrapperConnected = connect(mapStateToProps, {
    sendPayerInfo: sendPayerInfoToSaga,
    setOptionPayment: setOptionPaymentMethod,
})(PaymentCreditCardWrapper);
